export const validateUser = (user) => {
  let errors = {};

  if (!user.name) {
    errors.name = "El campo Nombre es obligatorio.";
  }

  if (!user.lastName) {
    errors.lastName = "El campo Apellido es obligatorio.";
  }

  if (!user.documentType) {
    errors.documentType = "El campo Tipo de Documento es obligatorio.";
  }

  if (!user.dni) {
    errors.dni = "El campo Número de Documento es obligatorio.";
  } else if (user.dni.length !== 8) {
    errors.cuil = "El DNI debe tener 8 dígitos.";
  }

  if (!user.cuil) {
    errors.cuil = "El campo CUIL es obligatorio.";
  } else if (user.cuil.length !== 11) {
    errors.cuil = "El CUIL debe tener 11 dígitos.";
  }

  if (!user.civilStatus) {
    errors.civilStatus = "El campo Estado Civil es obligatorio.";
  }

  if (!user.nacionality) {
    errors.nacionality = "El campo Nacionalidad es obligatorio.";
  }

  if (!user.dateOfBirth) {
    errors.dateOfBirth = "El campo Fecha de Nacimiento es obligatorio.";
  }

  if (!user.placeOfBirth) {
    errors.placeOfBirth = "El campo Lugar de Nacimiento es obligatorio.";
  }

  if (!user.street) {
    errors.street = "El campo Domicilio es obligatorio.";
  }

  if (!user.numberStreet) {
    errors.numberStreet = "El campo Numero es obligatorio.";
  }

  if (!user.location) {
    errors.location = "El campo Localidad es obligatorio.";
  }

  if (!user.province) {
    errors.province = "El campo Provincia es obligatorio.";
  }

  if (!user.postalCode) {
    errors.postalCode = "El campo Codigo Postal es obligatorio.";
  }

  if (!user.SocioEconomicLevel) {
    errors.SocioEconomicLevel =
      "El campo Nivel Socio Económico es obligatorio.";
  }

  return errors;
};

export const validateEconomicInformation = (economicInfo) => {
  let errors = {};

  if (!economicInfo.IncomeOfHumanPerson) {
    errors.IncomeOfHumanPerson =
      "El campo Monto Transaccional Anual es obligatorio.";
  }

  if (!economicInfo.total_indebtedness_of_the_financial_system) {
    errors.total_indebtedness_of_the_financial_system =
      "El campo Total de endeudamiento del sistema financiero es obligatorio.";
  }

  if (!economicInfo.total_monthly_commitment_of_the_financial_system) {
    errors.total_monthly_commitment_of_the_financial_system =
      "El campo Total de compromiso mensual sistema financiero es obligatorio.";
  }

  if (!economicInfo.current_status_with_BCRA) {
    errors.current_status_with_BCRA =
      "El campo Situación vigente ante BCRA es obligatorio.";
  }

  return errors;
};

export const validateEmployerInformation = (employerInfo) => {
  let errors = {};

  if (!employerInfo.employer) {
    errors.employer = "El campo Empleador es obligatorio.";
  }

  if (!employerInfo.ActivityBeingCarriedOut) {
    errors.ActivityBeingCarriedOut =
      "El campo Actividad que desarrolla es obligatorio.";
  }

  if (!employerInfo.employerDomicile) {
    errors.employerDomicile = "El campo Domicilio empleador es obligatorio.";
  }

  if (!employerInfo.WorkActivity) {
    errors.WorkActivity = "El campo Actividad laboral es obligatorio.";
  }

  if (!employerInfo.activitySeniority) {
    errors.activitySeniority =
      "El campo Antigüedad en la actividad es obligatorio.";
  }

  return errors;
};

export const validateRelationshipWithMutual = (relationshipInfo) => {
  let errors = {};

  if (!relationshipInfo.relation) {
    errors.relation = "El campo Tipo de relación es obligatorio.";
  }

  if (!relationshipInfo.canal) {
    errors.canal = "El campo Canal es obligatorio.";
  }

  if (relationshipInfo.relation === "Socio") {
    if (!relationshipInfo.creditDate) {
      errors.creditDate = "El campo Fecha del credito es obligatorio.";
    }

    if (!relationshipInfo.amountOfCredit) {
      errors.amountOfCredit = "El campo Monto de crédito es obligatorio.";
    }

    if (!relationshipInfo.amountOfFees) {
      errors.amountOfFees = "El campo Cantidad de cuotas es obligatorio.";
    }

    if (!relationshipInfo.installmentAmount) {
      errors.installmentAmount = "El campo Monto de la cuota es obligatorio.";
    }

    if (!relationshipInfo.loanBank) {
      errors.loanBank = "El campo Nombre del prestamista es obligatorio.";
    }

    if (!relationshipInfo.affiliate) {
      errors.affiliate = "El campo Afiliado es obligatorio.";
    }

    if (!relationshipInfo.credit) {
      errors.credit = "El campo Crédito es obligatorio.";
    }
  }

  return errors;
};

export const validatePoliticalInformation = (politicalInfo) => {
  let errors = {};

  if (!politicalInfo.politicallyExposed) {
    errors.politicallyExposed =
      "El campo Es políticamente expuesto es obligatorio.";
  }

  return errors;
};
